import React from "react";

import TourModalContainer from "components/shared/Tour/TourModal/TourModalContainer";
import TourModal from "./TourModal";

class GourmetGrammarTourModalContainer extends TourModalContainer {
  render() {
    return (
      <TourModal
        projectId={this.props.projectId}
        showModal={this.props.showModal}
        redirectUrl={this.getCurrentUrlPath()}
        completedTour={this.state.completedTour}
        slidesLength={this.state.slidesLength}
        setCompletedTour={this.setCompletedTour}
        setSlidesLength={this.setSlidesLength}
        handleCloseModal={this.props.handleCloseModal}
        handleCloseClick={this.handleCloseClick}
        language={this.props.language}
      />
    );
  }
}

export default GourmetGrammarTourModalContainer;
